import PrimaryButton from "components/buttons/primary-button";
import TextDropdown from "components/inputs/text-dropdown";
import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import Typography from "components/typography";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PromoCard from "../../components/card";
import { PromoCardData } from "../../components/card/cardData";
import Placeholder from "images/png/discography-image-placeholder.png";
import api from "services/axiosInstance";
import { GetActiveArtist } from "services/user/getUser";
import { ITrackRelease } from "types/musicData";
import Toast from "components/toast";
import { error } from "console";
import { SongWithUrls } from "types/response-type";
import { ReleaseContainerWithUrls } from "types/response-type";

const CreatePromoCard = () => {
  const [track, setTrack] = useState<ITrackRelease>();
  // const [trackImage, setTrackImage] = useState(Placeholder);
  const [trackImage, setTrackImage] = useState("");
  const [trackTitle, setTrackTitle] = useState("");
  const [trackTitles, setTrackTitles] = useState<string[]>([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [songs, setSongs] = useState<
    (SongWithUrls | ReleaseContainerWithUrls)[]
  >([]);
  const artist = GetActiveArtist();

  const GetDiscography = async () => {
    setDataLoading(true);
    try {
      const { data } = await api.get(`/songs/artist/${artist?.id}/discography`);

      if (!data.data) {
        return;
      }

      const { singles, albums, eps } = data.data;
      const singleData: SongWithUrls[] = singles;
      const albumData: ReleaseContainerWithUrls[] = albums;
      const epData: ReleaseContainerWithUrls[] = eps;
      const discography = [...singleData, ...albumData, ...epData];

      setSongs(discography);
      let trackNames: string[] = [];
      for (let i = 0; i < discography.length; i++) {
        trackNames.push(discography[i].title);
      }
      setTrackTitles([...trackNames]);
    } catch (error) {
      Toast({ error });
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    GetDiscography();
  }, []);

  const GenerateDisabled = useMemo(() => {
    if (trackTitle === "") {
      return true;
    }
    return false;
  }, [trackTitle]);

  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Promo Cards", link: "/overview/promo-cards" }}
          current="Create"
        />
        <Header>
          <Typography
            color={Colors.white100}
            size="4xl"
            weight="bold"
            m_size="xl"
          >
            Promo Cards
          </Typography>
          <HeaderItem>
            <DropdownContainer>
              <TextDropdown
                items={trackTitles}
                selectItem={(title) => {
                  setTrackTitle(title);
                }}
                chosenItem={trackTitle}
                value={trackTitle}
                placeholder="Choose A Track/ EP / Album"
                dataLoading={dataLoading}
              />
            </DropdownContainer>
            <PrimaryButton
              text="Generate"
              fitContent
              disabled={GenerateDisabled}
              onClick={() => {
                const song = songs.find((song) => song.title === trackTitle);
                console.log(song?.coverArtPath);
                setTrackImage(song?.coverArtPath || "");
              }}
            />
          </HeaderItem>
        </Header>
        <Grid>
          {PromoCardData.map(({ cardImage, cardName, variant }, i) => {
            return (
              <PromoCard
                key={i}
                cardImage={cardImage}
                cardName={cardName}
                trackImage={trackImage}
                variant={variant}
              />
            );
          })}
        </Grid>
      </>
    </DashboardLayout>
  );
};

export default CreatePromoCard;

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid ${Colors.grey600};
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1.6rem;
  }
`;

const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const DropdownContainer = styled.div`
  width: 26rem;
  @media only screen and (max-width: 769px) {
    width: 75%;
  }
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-row-gap: 1.6rem;
  grid-column-gap: 1.6rem;
  align-items: center;
  justify-content: space-between;
  padding-top: 3.2rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    margin-bottom: 2rem;
  }
`;
